import { useFormikContext } from 'formik';
import { useState } from 'react';
import { Button } from 'shared-components';
import { ButtonIntent } from 'shared-components';
import { Currency } from '../currency/currency';
import { useGetProductsQuery } from '../products/products.api';
// import { Product } from '../products/products.types';
// import { Event } from './events.types';
import styles from './event-pricing.module.css';
import { IEvent, IProduct } from '@topshots/core-models';
import { Select } from 'shared-components';
import { Input } from 'shared-components';

export const EventPricing = ({ event }: { event?: IEvent }) => {
  const { data, isLoading, isFetching } = useGetProductsQuery({
    page: 1,
    perPage: 10000,
  });
  const { setFieldValue, values } = useFormikContext<IEvent>();
  const [newOverridePrice, setNewOverridePrice] = useState<number>(0);
  const [newOverrideProduct, setNewOverrideProduct] = useState<IProduct | null>(
    data?.data[3] ?? null
  );
  if (isLoading || isFetching) return <span>loading...</span>;

  return (
    <table>
      <thead>
        <tr>
          <th>Product</th>
          <th colSpan={2}>Override price</th>
        </tr>
      </thead>
      <tbody>
        {values.pricingOverrides.map((p, i) => (
          <tr key={(p.product_id as IProduct)._id.toString()}>
            <td>{(p.product_id as IProduct).name}</td>
            <td>
              <Currency value={p.price} />
              &nbsp;
              <span className={styles.subtext}>
                (Normally: <Currency value={(p.product_id as IProduct).price} />
                )
              </span>
            </td>
            <td>
              <Button
                onClick={() => {
                  setFieldValue('pricingOverrides', [
                    ...values.pricingOverrides.slice(0, i),
                    ...values.pricingOverrides.slice(i + 1),
                  ]);
                }}
                type="button"
                intent={ButtonIntent.Negative}
              >
                Remove
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td>
            <Select
              onChange={(e) => {
                setNewOverrideProduct(
                  data?.data.find((p) => p._id.toString() === e.target.value) ??
                    null
                );
              }}
              value={newOverrideProduct?._id.toString()}
            >
              <option value="">Select a product</option>
              {data?.data
                .filter(
                  (i) =>
                    values.pricingOverrides
                      .map((pi) => pi.product_id._id)
                      .indexOf(i._id) === -1
                )
                .map((p) => (
                  <option value={p._id.toString()} key={p._id.toString()}>
                    {p.name}
                  </option>
                ))}
            </Select>
          </td>
          <td>
            <Input
              onChange={(e) => {
                setNewOverridePrice(Number(e.target.value));
              }}
              type="number"
              defaultValue={0}
            />
          </td>
          <td>
            <Button
              onClick={() => {
                if (!newOverrideProduct) return false;

                setFieldValue('pricingOverrides', [
                  ...values.pricingOverrides,
                  {
                    product_id: newOverrideProduct,
                    price: newOverridePrice,
                  },
                ]);
                setNewOverrideProduct(null);
                setNewOverridePrice(0);
              }}
              type="button"
            >
              Add
            </Button>
          </td>
        </tr>
      </tfoot>
    </table>
  );
};
